import { CALL_HISTORY_METHOD } from '../reducers/location';

export default function routerMiddleware(history) {
  // eslint-disable-next-line consistent-return
  return () => next => (action) => {
    if (action.type !== CALL_HISTORY_METHOD) {
      return next(action);
    }

    const { payload: { method, args } } = action;
    history[method](...args);
  };
}
